/**
 * Resolves a stored image path to a fully-qualified URL.
 *
 * - External URLs (http/https) are returned as-is.
 * - Relative /uploads/ paths are prefixed with the API origin so they
 *   always load correctly whether the app is served over HTTP or HTTPS.
 */
const PROD_API_ORIGIN = "https://api.expertatdoor.com";
const isProdHost =
  typeof window !== "undefined" &&
  /(^|\.)expertatdoor\.com$/.test(window.location.hostname) &&
  window.location.hostname !== "api.expertatdoor.com";

const API_ORIGIN = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace(/\/api\/?$/, "") // strip trailing /api
  : isProdHost
    ? PROD_API_ORIGIN
    : ""; // same origin in dev

const resolveImage = (path) => {
  if (!path) return null;
  if (/^https?:\/\//.test(path)) return path; // already absolute
  if (path.startsWith("/uploads/")) return `${API_ORIGIN}${path}`;
  return path;
};

export default resolveImage;
